import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface SynchronizationInterface {
    sendOfflineData(triggerSyncEvent?: boolean): Observable<void>;
    receiveWhatsNew(triggerSyncEvent?: boolean): Observable<void>;
    receiveEverything(triggerSyncEvent?: boolean): Observable<void>;
    receiveEverythingCacheFirst(triggerSyncEvent?: boolean): Observable<void>;
    sendOfflineDataAndReceiveNotificationsAndBootStock(): Observable<void>;
    flushCompletely(): Observable<boolean>;
    receiveNotifications(triggerSyncEvent?: boolean): Observable<void>;
}

export const SynchronizationInstanceToken = new InjectionToken<SynchronizationInterface>('SynchronizationInterface');
